import { render } from "./FilterTableCod3Component.vue?vue&type=template&id=c7cab5ac"
import script from "./FilterTableCod3Component.vue?vue&type=script&lang=js"
export * from "./FilterTableCod3Component.vue?vue&type=script&lang=js"

import "./FilterTableCod3Component.vue?vue&type=style&index=0&id=c7cab5ac&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__